// ✅ Watch data
const appleWatches = [
  {
    "title": "Apple Watch Series 11",
    "landingPage": "https://cforcover.com/collections/apple-watch-series-11",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Watch_11.jpg?v=1759145473"
  },
  {
    "title": "Apple Watch Series 10",
    "landingPage": "https://cforcover.com/collections/apple-watch-series-10",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Watch_10.jpg?v=1759145473"
  },
  {
    "title": "Apple Watch Ultra 2",
    "landingPage": "https://cforcover.com/collections/apple-watch-ultra-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-watch-ultra2-black.jpg?v=1759145473"
  },
  {
    "title": "Apple Watch Ultra",
    "landingPage": "https://cforcover.com/collections/apple-watch-ultra",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/apple-watch-ultra.jpg?v=1759145472"
  },
  {
    "title": "Apple Watch Series SE",
    "landingPage": "https://cforcover.com/collections/apple-watch-series-se",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/5e3f3019-89e6.avif?v=1759145733"
  },
  {
    "title": "Apple Watch Series 9",
    "landingPage": "https://cforcover.com/collections/apple-watch-series-9",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Watch_9.jpg?v=1759145473"
  },
  {
    "title": "Apple Watch Series 8",
    "landingPage": "https://cforcover.com/collections/apple-watch-series-8",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Watch_8.jpg?v=1759145473"
  },
  {
    "title": "Apple Watch Series 7",
    "landingPage": "https://cforcover.com/collections/apple-watch-series-7",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Watch_7.jpg?v=1759145473"
  },
  {
    "title": "Apple Watch Series 6",
    "landingPage": "https://cforcover.com/collections/apple-watch-series-6",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Watch_6.jpg?v=1759145473"
  },
  {
    "title": "Apple Watch Series 5",
    "landingPage": "https://cforcover.com/collections/apple-watch-series-5",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Watch_5.jpg?v=1759145473"
  },
  {
    "title": "Apple Watch Series 4",
    "landingPage": "https://cforcover.com/collections/apple-watch-series-4",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Watch_4.jpg?v=1759145473"
  },
  {
    "title": "Apple Watch Series 3",
    "landingPage": "https://cforcover.com/collections/apple-watch-series-3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Watch_3.jpg?v=1759145473"
  },
  {
    "title": "Apple Watch Series 2",
    "landingPage": "https://cforcover.com/collections/apple-watch-series-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Watch_2.jpg?v=1759145473"
  },
  {
    "title": "Apple Watch Series 1",
    "landingPage": "https://cforcover.com/collections/apple-watch-series-1",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Watch_1.jpg?v=1759145473"
  }
]

const samsungWatches = [
  {
    "title": "Samsung Galaxy Watch Ultra",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-watch-ultra",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-watch-ultra.jpg?v=1759147018"
  },
  {
    "title": "Samsung Galaxy Watch 8 Classic",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-watch-8-classic",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-watch8-classic.jpg?v=1759147019"
  },
  {
    "title": "Samsung Galaxy Watch 8",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-watch-8",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-watch8.jpg?v=1759147019"
  },
  {
    "title": "Samsung Galaxy Watch 7",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-watch-7",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-watch7.jpg?v=1759147019"
  },
  {
    "title": "Samsung Galaxy Watch 6 Classic",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-watch-6-classic",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-watch6-classic.jpg?v=1759147020"
  },
  {
    "title": "Samsung Galaxy Watch 6",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-watch-6",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-watch6.jpg?v=1759147020"
  },
  {
    "title": "Samsung Galaxy Watch FE",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-watch-fe",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-watch-fe-r.jpg?v=1759147020"
  },
  {
    "title": "Samsung Galaxy Watch 5 Pro",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-watch-5-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-watch5pro.jpg?v=1759147019"
  },
  {
    "title": "Samsung Galaxy Watch 5",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-watch-5",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-watch5.jpg?v=1759147019"
  },
  {
    "title": "Samsung Galaxy Watch 4 Classic",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-watch-4-classic",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-watch4-classic.jpg?v=1759147019"
  },
  {
    "title": "Samsung Galaxy Watch 4",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-watch-4",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-watch4.jpg?v=1759147019"
  },
  {
    "title": "Samsung Galaxy Watch 3",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-watch-3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-watch3.jpg?v=1759147019"
  },
  {
    "title": "Samsung Galaxy Watch Active 2",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-watch-active-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-watch-active2.jpg?v=1759147019"
  },
  {
    "title": "Samsung Galaxy Watch Active",
    "landingPage": "https://cforcover.com/collections/samsung-galaxy-watch-active",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/samsung-galaxy-watch-active.jpg?v=1759147019"
  }
]

const noiseWatches = [
  {
    "title": "ColorFit Pulse",
    "landingPage": "https://cforcover.com/collections/colorfit-pulse",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Pulse.webp?v=1759149344"
  },
  {
    "title": "ColorFit Pulse Go Buzz",
    "landingPage": "https://cforcover.com/collections/colorfit-pulse-go-buzz",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Pulse_Go_Buzz.webp?v=1759149344"
  },
  {
    "title": "ColorFit Loop",
    "landingPage": "https://cforcover.com/collections/colorfit-loop",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Loop.webp?v=1759149344"
  },
  {
    "title": "ColorFit Icon Buzz",
    "landingPage": "https://cforcover.com/collections/colorfit-icon-buzz",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Icon_Buzz.webp?v=1759149344"
  },
  {
    "title": "ColorFit Icon 2",
    "landingPage": "https://cforcover.com/collections/colorfit-icon-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Icon_2.jpg?v=1759149344"
  },
  {
    "title": "ColorFit Icon 3",
    "landingPage": "https://cforcover.com/collections/colorfit-icon-3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Icon_3.jpg?v=1759149344"
  },
  {
    "title": "ColorFit Icon 4",
    "landingPage": "https://cforcover.com/collections/colorfit-icon-4",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Icon_4.jpg?v=1759149344"
  },
  {
    "title": "ColorFit Icon Pro 4",
    "landingPage": "https://cforcover.com/collections/colorfit-icon-pro-4",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Icon_Pro_4.webp?v=1759149344"
  },
  {
    "title": "ColorFit Icon 5",
    "landingPage": "https://cforcover.com/collections/colorfit-icon-5",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Icon_5.webp?v=1759149344"
  },
  {
    "title": "ColorFit Icon Pro 5",
    "landingPage": "https://cforcover.com/collections/colorfit-icon-pro-5",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Icon_Pro_5.webp?v=1759149344"
  },
  {
    "title": "NoiseFit Endure",
    "landingPage": "https://cforcover.com/collections/noisefit-endure",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/NoiseFit_Endure.jpg?v=1759149344"
  },
  {
    "title": "NoiseFit Nav Plus",
    "landingPage": "https://cforcover.com/collections/noisefit-nav-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/NoiseFit_Nav_b9f2ac1d-82b5-4a1d-9359-618570525237.webp?v=1759149344"
  },
  {
    "title": "NoiseFit Nav",
    "landingPage": "https://cforcover.com/collections/noisefit-nav",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/NoiseFit_Nav.webp?v=1759149343"
  },
  {
    "title": "NoiseFit Active",
    "landingPage": "https://cforcover.com/collections/noisefit-active",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/NoiseFit_Active.webp?v=1759149344"
  },
  {
    "title": "ColorFit Vision 3",
    "landingPage": "https://cforcover.com/collections/colorfit-vision-3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Vision_3.webp?v=1759149344"
  },
  {
    "title": "ColorFit Vision 2 Buzz",
    "landingPage": "https://cforcover.com/collections/colorfit-vision-2-buzz",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Vision_2_Buzz.webp?v=1759149344"
  },
  {
    "title": "ColorFit Vision 2",
    "landingPage": "https://cforcover.com/collections/colorfit-vision-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Vision_2.webp?v=1759149344"
  },
  {
    "title": "ColorFit Caliber Max",
    "landingPage": "https://cforcover.com/collections/colorfit-caliber-max",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Caliber_Max.jpg?v=1759149344"
  },
  {
    "title": "ColorFit Caliber 3 Plus",
    "landingPage": "https://cforcover.com/collections/colorfit-caliber-3-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Caliber_3_Plus.webp?v=1759149344"
  },
  {
    "title": "ColorFit Caliber 3",
    "landingPage": "https://cforcover.com/collections/colorfit-caliber-3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Caliber_3.webp?v=1759149344"
  },
  {
    "title": "ColorFit Caliber Buzz",
    "landingPage": "https://cforcover.com/collections/colorfit-caliber-buzz",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Caliber_Buzz.webp?v=1759149344"
  },
  {
    "title": "ColorFit Caliber 2 Buzz",
    "landingPage": "https://cforcover.com/collections/colorfit-caliber-2-buzz",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Caliber_2_Buzz.webp?v=1759149344"
  },
  {
    "title": "ColorFit Caliber 2",
    "landingPage": "https://cforcover.com/collections/colorfit-caliber-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Caliber_2.webp?v=1759149344"
  },
  {
    "title": "ColorFit Caliber Go",
    "landingPage": "https://cforcover.com/collections/colorfit-caliber-go",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Caliber_Go.webp?v=1759149344"
  },
  {
    "title": "ColorFit Caliber",
    "landingPage": "https://cforcover.com/collections/colorfit-caliber",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Caliber.webp?v=1759149344"
  },
  {
    "title": "NoiseFit Core 2",
    "landingPage": "https://cforcover.com/collections/noisefit-core-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/NoiseFit_Core_2.webp?v=1759149344"
  },
  {
    "title": "ColorFit Icon 2 Vista",
    "landingPage": "https://cforcover.com/collections/colorfit-icon-2-vista",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Icon_2_Vista.webp?v=1759149344"
  },
  {
    "title": "ColorFit Ultra 3 Luminary",
    "landingPage": "https://cforcover.com/collections/colorfit-ultra-3-luminary",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Ultra_3_Luminary.webp?v=1759149344"
  },
  {
    "title": "ColorFit Ultra 2 Buzz",
    "landingPage": "https://cforcover.com/collections/colorfit-ultra-2-buzz",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Ultra_2_Buzz.webp?v=1759149344"
  },
  {
    "title": "ColorFit Ultra 2 Le",
    "landingPage": "https://cforcover.com/collections/colorfit-ultra-2-le",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Ultra_2_Le.webp?v=1759149344"
  },
  {
    "title": "ColorFit Ultra Buzz",
    "landingPage": "https://cforcover.com/collections/colorfit-ultra-buzz",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Ultra_Buzz.webp?v=1759149344"
  },
  {
    "title": "ColorFit Ultra 2",
    "landingPage": "https://cforcover.com/collections/colorfit-ultra-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Ultra_2.webp?v=1759149344"
  },
  {
    "title": "ColorFit Ultra",
    "landingPage": "https://cforcover.com/collections/colorfit-ultra",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Ultra.webp?v=1759149905"
  },
  {
    "title": "ColorFit Ultra 3",
    "landingPage": "https://cforcover.com/collections/colorfit-ultra-3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Ultra_3.webp?v=1759149344"
  },
  {
    "title": "ColorFit Pro 3 Assist",
    "landingPage": "https://cforcover.com/collections/colorfit-pro-3-assist",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/ColorFit_Pro_3_Assist.webp?v=1759149344"
  }
]

const boatWatches = [
  {
    "title": "Boat Xplorer 02",
    "landingPage": "https://cforcover.com/collections/boat-xplorer-02",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Xplorer_02.webp?v=1759228207"
  },
  {
    "title": "Boat Wave Lite",
    "landingPage": "https://cforcover.com/collections/boat-wave-lite",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Wave_Lite.webp?v=1759228207"
  },
  {
    "title": "Boat Xtend",
    "landingPage": "https://cforcover.com/collections/boat-xtend",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Xtend.webp?v=1759228207"
  },
  {
    "title": "Boat Vertex",
    "landingPage": "https://cforcover.com/collections/boat-vertex",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Vertex.webp?v=1759228208"
  },
  {
    "title": "Boat Mystiq",
    "landingPage": "https://cforcover.com/collections/boat-mystiq",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Mystiq.webp?v=1759228207"
  },
  {
    "title": "Boat Iris",
    "landingPage": "https://cforcover.com/collections/boat-iris",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Iris.webp?v=1759228207"
  },
  {
    "title": "Boat Flash",
    "landingPage": "https://cforcover.com/collections/boat-flash",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Flash.webp?v=1759228207"
  },
  {
    "title": "Boat Delta",
    "landingPage": "https://cforcover.com/collections/boat-delta",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Delta.webp?v=1759228207"
  },
  {
    "title": "Boat Blaze",
    "landingPage": "https://cforcover.com/collections/boat-blaze",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Blaze.webp?v=1759228207"
  },
  {
    "title": "Boat Enigma X500",
    "landingPage": "https://cforcover.com/collections/boat-enigma-x500",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Enigma_X500_e40aef90-9c94-4b0d-9add-ee07853741b0.webp?v=1759228207"
  },
  {
    "title": "Boat Enigma X600",
    "landingPage": "https://cforcover.com/collections/boat-enigma-x600",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Enigma_X600_b2bcf778-6a90-4d29-8ba1-f8ff10ee1814.webp?v=1759228207"
  },
  {
    "title": "Boat Enigma Z30",
    "landingPage": "https://cforcover.com/collections/boat-enigma-z30",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Enigma_Z30.webp?v=1759228207"
  },
  {
    "title": "Boat Enigma R32",
    "landingPage": "https://cforcover.com/collections/boat-enigma-r32",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Enigma_R32.webp?v=1759228208"
  },
  {
    "title": "Boat Enigma Z20",
    "landingPage": "https://cforcover.com/collections/boat-enigma-z20",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Enigma_Z20.webp?v=1759228207"
  },
  {
    "title": "Boat Enigma Daze",
    "landingPage": "https://cforcover.com/collections/boat-enigma-daze",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Enigma_Daze.webp?v=1759228208"
  },
  {
    "title": "Boat Enigma Gem",
    "landingPage": "https://cforcover.com/collections/boat-enigma-gem",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Enigma_Gem.webp?v=1759228208"
  },
  {
    "title": "Boat Enigma Switch",
    "landingPage": "https://cforcover.com/collections/boat-enigma-switch",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Enigma_Switch.webp?v=1759228208"
  },
  {
    "title": "Boat Enigma Orion",
    "landingPage": "https://cforcover.com/collections/boat-enigma-orion",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Enigma_Orion.webp?v=1759228207"
  },
  {
    "title": "Boat Enigma Radiant",
    "landingPage": "https://cforcover.com/collections/boat-enigma-radiant",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Enigma_Radiant.webp?v=1759228208"
  },
  {
    "title": "Boat Wave Pro 47",
    "landingPage": "https://cforcover.com/collections/boat-wave-pro-47",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Wave_Pro_47.webp?v=1759228208"
  },
  {
    "title": "Boat Wave Pro",
    "landingPage": "https://cforcover.com/collections/boat-wave-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Wave_Pro.webp?v=1759228207"
  },
  {
    "title": "Boat Watch Zenit",
    "landingPage": "https://cforcover.com/collections/boat-watch-zenit",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Watch_Zenit.webp?v=1759228207"
  },
  {
    "title": "Boat Watch Mercury",
    "landingPage": "https://cforcover.com/collections/boat-watch-mercury",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Watch_Mercury.webp?v=1759228207"
  },
  {
    "title": "Boat Watch Matrix",
    "landingPage": "https://cforcover.com/collections/boat-watch-matrix",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Boat_Watch_Matrix.webp?v=1759228207"
  }
]

const fireboltWatches = [
  {
    "title": "Fire-Boltt Ultimate",
    "landingPage": "https://cforcover.com/collections/fire-boltt-ultimate",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Ultimate.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Grenade",
    "landingPage": "https://cforcover.com/collections/fire-boltt-grenade",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Grenade.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Combat",
    "landingPage": "https://cforcover.com/collections/fire-boltt-combat",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Combat.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Rage",
    "landingPage": "https://cforcover.com/collections/fire-boltt-rage",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Rage.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Destiny",
    "landingPage": "https://cforcover.com/collections/fire-boltt-destiny",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Destiny.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Shark",
    "landingPage": "https://cforcover.com/collections/fire-boltt-shark",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Shark.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Phoenix Ultra",
    "landingPage": "https://cforcover.com/collections/fire-boltt-phoenix-ultra",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Phoenix_Ultra.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Phoenix Ultra Blaze",
    "landingPage": "https://cforcover.com/collections/fire-boltt-phoenix-ultra-blaze",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Phoenix_Ultra_Blaze.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Phoenix",
    "landingPage": "https://cforcover.com/collections/fire-boltt-phoenix",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Phoenix.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Phoenix Pro",
    "landingPage": "https://cforcover.com/collections/fire-boltt-phoenix-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Phoenix_Pro.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Phoenix Classic",
    "landingPage": "https://cforcover.com/collections/fire-boltt-phoenix-classic",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Phoenix_Classic.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Gladiator Plus",
    "landingPage": "https://cforcover.com/collections/fire-boltt-gladiator-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Gladiator_Plus.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Gladiator",
    "landingPage": "https://cforcover.com/collections/fire-boltt-gladiator",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Gladiator.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Gladiator Pro",
    "landingPage": "https://cforcover.com/collections/fire-boltt-gladiator-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Gladiator_Pro.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Supreme",
    "landingPage": "https://cforcover.com/collections/fire-boltt-supreme",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Supreme.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Visionary",
    "landingPage": "https://cforcover.com/collections/fire-boltt-visionary",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Visionary.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Visionary Ultra",
    "landingPage": "https://cforcover.com/collections/fire-boltt-visionary-ultra",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Visionary_Ultra.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Ring Plus",
    "landingPage": "https://cforcover.com/collections/fire-boltt-ring-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Ring_Plus.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Ring 3",
    "landingPage": "https://cforcover.com/collections/fire-boltt-ring-3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Ring_3.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Ring 2",
    "landingPage": "https://cforcover.com/collections/fire-boltt-ring-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Ring_2.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Ring X",
    "landingPage": "https://cforcover.com/collections/fire-boltt-ring-x",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Ring_X.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Ring Pro",
    "landingPage": "https://cforcover.com/collections/fire-boltt-ring-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Ring_Pro.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Bell",
    "landingPage": "https://cforcover.com/collections/fire-boltt-bell",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Bell.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Ninja Pro",
    "landingPage": "https://cforcover.com/collections/fire-boltt-ninja-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Ninja_Pro.webp?v=1759563945"
  },
  {
    "title": "Fire-Boltt Ninja Pro Max",
    "landingPage": "https://cforcover.com/collections/fire-boltt-ninja-pro-max",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Ninja_Pro_Max.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Ninja Call Pro Max",
    "landingPage": "https://cforcover.com/collections/fire-boltt-ninja-call-pro-max",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Ninja_Call_Pro_Max.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Ninja Pro Max Ultra",
    "landingPage": "https://cforcover.com/collections/fire-boltt-ninja-pro-max-ultra",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Ninja_Pro_Max_Ultra.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Ninja Pro Max Plus",
    "landingPage": "https://cforcover.com/collections/fire-boltt-ninja-pro-max-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Ninja_Pro_Max_Plus.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Ninja 3",
    "landingPage": "https://cforcover.com/collections/fire-boltt-ninja-3",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Ninja_3.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Ninja 3 Plus",
    "landingPage": "https://cforcover.com/collections/fire-boltt-ninja-3-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Ninja_3_Plus.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Ninja 2",
    "landingPage": "https://cforcover.com/collections/fire-boltt-ninja-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Ninja_2.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Ninja 2 Max",
    "landingPage": "https://cforcover.com/collections/fire-boltt-ninja-2-max",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Ninja_2_Max.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Tank",
    "landingPage": "https://cforcover.com/collections/fire-boltt-tank",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Tank.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Invincible Plus",
    "landingPage": "https://cforcover.com/collections/fire-boltt-invincible-plus",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Invincible_Plus.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Invincible",
    "landingPage": "https://cforcover.com/collections/fire-boltt-invincible",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Invincible.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt 360 Pro",
    "landingPage": "https://cforcover.com/collections/fire-boltt-360-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_360_Pro.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Mercury",
    "landingPage": "https://cforcover.com/collections/fire-boltt-mercury",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Mercury.webp?v=1759563945"
  },
  {
    "title": "Fire-Boltt Talk",
    "landingPage": "https://cforcover.com/collections/fire-boltt-talk",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Talk.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Talk 2",
    "landingPage": "https://cforcover.com/collections/fire-boltt-talk-2",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Talk_2.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Talk 2 Pro",
    "landingPage": "https://cforcover.com/collections/fire-boltt-talk-2-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Talk_2_Pro.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Talk 2 Pro Ultra",
    "landingPage": "https://cforcover.com/collections/fire-boltt-talk-2-pro-ultra",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/talk-2-pro-ultra-black_1_1800x1800_1a7ce948-ecaf-45a4-b43a-05bce9106769.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Talk Pro",
    "landingPage": "https://cforcover.com/collections/fire-boltt-talk-pro",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Talk_Pro.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Talk Go",
    "landingPage": "https://cforcover.com/collections/fire-boltt-talk-go",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Talk_Go.webp?v=1759563946"
  },
  {
    "title": "Fire-Boltt Talk Ultra",
    "landingPage": "https://cforcover.com/collections/fire-boltt-talk-ultra",
    "imagePath": "https://cdn.shopify.com/s/files/1/0744/0816/5684/files/Fire-Boltt_Talk_Ultra.webp?v=1759563946"
  }
]



document.addEventListener("DOMContentLoaded", function () {
  const watchProducts = [...appleWatches, ...samsungWatches, ...noiseWatches, ...boatWatches, ...fireboltWatches];

  // ✅ Match HTML IDs & classes
  const globalSearch = document.querySelector("#global-search-input-watch");
  const displayGlobally = document.querySelector(".display-models-globally-watch");

  // ✅ Display function
  const displayWatches = (modelObject) => {
    // console.log("Displaying watch:", modelObject);  // Log the watch model

    const anchor = document.createElement("a");
    const div1 = document.createElement("div");
    const div2 = document.createElement("div");
    const image = document.createElement("img");
    const para = document.createElement("p");

    anchor.href = modelObject.landingPage;
    anchor.target = "_blank";
    anchor.style.textDecoration = "none";

    div1.className = "one-item";

    image.src = modelObject.imagePath;
    image.alt = modelObject.title;

    para.textContent = modelObject.title;

    div2.appendChild(image);
    div1.appendChild(div2);
    div1.appendChild(para);
    anchor.appendChild(div1);

    displayGlobally.appendChild(anchor);
  };

  // ✅ Search function
  function searchWatch() {
    const searchValue = globalSearch.value.trim().toLowerCase();
    // console.log("Search input:", searchValue);  // Log the search query

    const searchResult = watchProducts.filter((obj) =>
      obj.title.toLowerCase().includes(searchValue)
    );

    displayGlobally.innerHTML = "";  // Clear previous results

    if (searchResult.length > 0) {
      // console.log("Search results:", searchResult);  // Log search results
      searchResult.forEach((obj) => displayWatches(obj));
      displayGlobally.style.display = "block";
    } else {
      displayGlobally.style.display = "none";
    }

    if (globalSearch.value === "") {
      displayGlobally.innerHTML = "";
      displayGlobally.style.display = "none";
    }
  }

  // ✅ Hide on outside click
  document.addEventListener("click", (event) => {
    if (!displayGlobally.contains(event.target) && event.target !== globalSearch) {
      displayGlobally.style.display = "none";
      globalSearch.value = "";
    }
  });

  // ✅ Input listener
  globalSearch.addEventListener("input", searchWatch);

  // ✅ Default state
  displayGlobally.style.display = "none";
});

